var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.469,
    height: 14.041,
    viewBox: "0 0 8.469 14.041",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.578 0.539)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "edit",
    d: "M1479.822,140.577l4.371-9.513a.49.49,0,0,1,.649-.241l1.949.89a.488.488,0,0,1,.241.648l-4.371,9.513",
    transform: "translate(-1479.688 -130.778)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "edit",
    x2: 2.894,
    y2: 1.326,
    transform: "translate(3.782 1.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "edit",
    d: "M1479.386,178.3l-.209.46.211,2.71a.347.347,0,0,0,.452.192L1482.1,180l.181-.376",
    transform: "translate(-1479.177 -168.691)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "edit",
    x2: 2.788,
    y2: 1.277,
    transform: "translate(0.085 9.951)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.338d8abe.svg";
export { ForwardRef as ReactComponent };